/**
 * Payroll Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const payrollAPI = {
  getAll: (params) => apiClient.get('/payroll', { params }),
  getById: (id) => apiClient.get(`/payroll/${id}`),
  getSummary: (params) => apiClient.get('/payroll/stats/summary', { params }),
  create: (data) => apiClient.post('/payroll', data),
  update: (id, data) => apiClient.put(`/payroll/${id}`, data),
  delete: (id) => apiClient.delete(`/payroll/${id}`),
  getPaystubPdf: (id) => apiClient.get(`/payroll/${id}/pdf`, { responseType: 'blob' }),
};

export default payrollAPI;

